export default __webpack_public_path__ + "static/media/load.03efd336.svg";